import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const host = style({
  display: 'flex',
  alignItems: 'center',
});

const option = style({
  display: 'flex',
  alignItems: 'center',
  gap: themeVars.spacing.xs,
  marginRight: themeVars.spacing.lg,
  color: themeVars.color.semantic.text.neutral20,
  fontSize: themeVars.font.sm,
  cursor: 'pointer',
  opacity: 0.7,
});

const selected = style({
  opacity: 1,
  fontWeight: 'bold',
  color: themeVars.color.semantic.text.neutral30,
});

export const css = {
  host,
  option,
  selected,
};
